import React from "react";
import PropTypes from "prop-types";

const shapes = {
  round: "rounded-[18px]",
};
const variants = {
  fill: {
    deep_purple_A200: "bg-deep_purple-a200 text-white",
    yellow_main: "bg-yellow_main text-dark_blue_secondary",
    orange_accent1: "bg-orange_accent1",
  },
};


const Button = ({
  children,
  className = "",
  leftIcon,
  rightIcon,
  shape,
  variant = "fill",
  color = "yellow_main",
  ...restProps
}) => {
  return (
    <button
      className={`${className} flex flex-row items-center justify-center text-center cursor-pointer whitespace-nowrap ${shape && shapes[shape]} ${variant && variants[variant]?.[color]}`}
      {...restProps}
    >
      {!!leftIcon && leftIcon}
      {children}
      {!!rightIcon && rightIcon}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  shape: PropTypes.oneOf(["round"]),
  size: PropTypes.oneOf(["md", "lg", "sm", "xs"]),
  variant: PropTypes.oneOf(["fill"]),
  color: PropTypes.oneOf(["deep_purple_A200", "yellow_main", "orange_accent1"]),
};

export { Button };
